import { createContext } from 'react';
import { DefaultMetadata, ProjectMetadataContextValue } from './project-metadata-type';

export const ProjectMetadataContext = createContext<ProjectMetadataContextValue>({
    metadata: {} as DefaultMetadata,
    setMetadata: (_metadata: Partial<DefaultMetadata>) => {}
});